export class Memento<T = unknown> {
	private readonly diff: Partial<T>;

	constructor(diff: Partial<T>) {
		this.diff = { ...diff };
	}

	getDiff(): Partial<T> {
		return { ...this.diff };
	}
}
